import {COMMERCE} from '../src/commerce-types';
import {EARNINGS_PATH} from '../src/commerce-earnings-types';

export type AccountDestination = {path: string; label: string; icon: string; chatContext?: boolean};

export const WORKSPACE_NAVIGATION: readonly AccountDestination[] = [
  {path: '/workspace', label: 'Workspace', icon: 'house', chatContext: true},
  {path: '/agents', label: 'Your team', icon: 'users', chatContext: true},
  {path: '/tasks', label: 'Tasks', icon: 'list-checks', chatContext: true},
  {path: '/files', label: 'Files', icon: 'folder', chatContext: true},
  {path: '/desktop', label: 'Desktop', icon: 'terminal'},
  {path: '/messages', label: 'Messages', icon: 'bell'},
];
export const SERVICE_NAVIGATION: readonly AccountDestination[] = COMMERCE.products.map(product => ({
  path: product.accountPath, label: product.name.replace(/^EightBots /, ''),
  icon: product.id === 'domains' ? 'globe' : product.id === 'crypto' ? 'coins' : 'credit-card',
}));
export const ACCOUNT_NAVIGATION: readonly AccountDestination[] = [
  {path: EARNINGS_PATH, label: 'Earnings', icon: 'chart-no-axes-combined'},
  {path: '/billing', label: 'Usage & Billing', icon: 'credit-card'},
  {path: '/account/invoices', label: 'Invoices', icon: 'list-checks'},
  {path: '/settings', label: 'Settings', icon: 'settings', chatContext: true},
];
export const ACCOUNT_DESTINATIONS = [...WORKSPACE_NAVIGATION, ...SERVICE_NAVIGATION, ...ACCOUNT_NAVIGATION];
